import { bl_alg_cc_qc_set_RowClass as  bl_alg_cc_qc_set_RowClass } from "../../../../dbschema/bl_alg_cc_qc_set.model";
import { BaseContainerModel } from "../../../base-container.model";

export class QualityControlSetContainerModel extends BaseContainerModel {

    bl_alg_cc_qc_set_hdr: bl_alg_cc_qc_set_RowClass = new bl_alg_cc_qc_set_RowClass();    
	
}
